export default "__VITE_ASSET__DQr65m6N__"